






import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class GroupView extends Vue {
  @Prop({ default: '',  type: String}) groupId!: string;

  extractEnterprise():string {
    let groupList = this.groupId.split('.');
    return groupList.length === 2 ? groupList[0] : this.groupId.split('.').slice(1, -1).join(' > ');
  }


  extractSubgroup(groupId:string):string {
    let subgroupId = groupId.split('.').reverse()[0] as string;
    return subgroupId === 'master' ? '' : subgroupId
  }
}
